import { Funcionalidade } from '../models/funcionalidade.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import { Observable } from 'rxjs';


@Injectable()
export class FuncionalidadeService {


    constructor(private http: HttpClient, private account: AccountService) { }


    registrar(data)  {
        return this.http.post(`${SCAMP_API.accountApiV1}/funcionalidade`, data, {headers : this.account.composeHeaders()});
    }

    create(data)  {
        return this.http.post(`${SCAMP_API.accountApiV1}/funcionalidade`, data, {headers : this.account.composeHeaders()});
    }

    editar(id: number, data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/funcionalidade/${id}`, data, {headers : this.account.composeHeaders()});
    }

    getFuncionalidades(): Observable<Funcionalidade[]> {
        return this.http.get<Funcionalidade[]>(`${SCAMP_API.accountApiV1}/funcionalidades`, {headers : this.account.composeHeaders()});
    }

    list(): Observable<Funcionalidade[]> {
        return this.http.get<Funcionalidade[]>(`${SCAMP_API.accountApiV1}/funcionalidades`, {headers : this.account.composeHeaders()});
    }

    getFuncionalidade(id: number): Observable<Funcionalidade> {
        return this.http.get<Funcionalidade>(`${SCAMP_API.accountApiV1}/funcionalidade/${id}`, {headers : this.account.composeHeaders()});
    }

    read(id: number): Observable<Funcionalidade> {
        return this.http.get<Funcionalidade>(`${SCAMP_API.accountApiV1}/funcionalidade/${id}`, {headers : this.account.composeHeaders()});
    }


    getFuncionalidadesNivelUsuarios(nivel: number, usuarioConsultadoId: number): Observable<Funcionalidade[]> {

        return this.http.get<Funcionalidade[]>(
            `${SCAMP_API.accountApiV1}/funcionalidades-nivel-usuarios/${nivel}/${usuarioConsultadoId}`,
            {headers : this.account.composeHeaders()}
            );
    }

    isUniqueNomeFuncionalidade(nome: string): Observable<boolean> {
        return this.http.post<boolean>(
            `${SCAMP_API.accountApiV1}/nome-funcionalidade-is-unique`, {nome},
            {headers : this.account.composeHeaders()}
            );
    }

    delete(id: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/funcionalidade/${id}`, {headers : this.account.composeHeaders()});
    }

    ativarDesativar(id: number) {
        return this.http.put(
            `${SCAMP_API.accountApiV1}/funcionalidade-ativar-desativar/${id}`, '',
            { headers: this.account.composeHeaders() }
            );
    }

}
